import React, { useState, useEffect, useCallback } from 'react';
import { getLeaveRequests, reviewLeave, getEmployees } from '../api';

const STATUS_COLORS = { pending: '#d97706', approved: '#059669', rejected: '#dc2626' };
const card = { background: 'var(--glass)', backdropFilter: 'var(--blur)', WebkitBackdropFilter: 'var(--blur)', border: '1px solid var(--glass-border)', borderRadius: 12, padding: 20 };
const inp = { padding: '8px 11px', border: '1px solid var(--glass-border)', borderRadius: 8, fontSize: 13, background: 'var(--glass-2)', color: 'var(--text)' };

export default function ManageLeave() {
  const [rows, setRows] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [statusFilter, setStatusFilter] = useState('pending');
  const [empFilter, setEmpFilter] = useState('');
  const [err, setErr] = useState('');

  const load = useCallback(async () => {
    setErr('');
    try {
      const params = {};
      if (statusFilter !== 'all') params.status = statusFilter;
      if (empFilter) params.employee_id = empFilter;
      setRows(await getLeaveRequests(params));
    } catch (e) { setErr(e.response?.data?.error || 'Failed to load'); }
  }, [statusFilter, empFilter]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { getEmployees().then(setEmployees).catch(() => {}); }, []);

  const review = async (id, status) => {
    setErr('');
    try { await reviewLeave(id, status); load(); }
    catch (e) { setErr(e.response?.data?.error || 'Failed to update'); }
  };

  const pendingCount = rows.filter(r => r.status === 'pending').length;

  return (
    <div style={{ padding: 24, maxWidth: 1000, margin: '0 auto' }}>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--text)', margin: '0 0 4px' }}>Manage Leave</h1>
      <p style={{ color: 'var(--muted)', margin: '0 0 20px', fontSize: 14 }}>Review and approve or reject leave requests from your team.</p>

      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 16, alignItems: 'center' }}>
        <select style={inp} value={statusFilter} onChange={e => setStatusFilter(e.target.value)}>
          <option value="pending">Pending{statusFilter === 'pending' && pendingCount ? ` (${pendingCount})` : ''}</option>
          <option value="approved">Approved</option>
          <option value="rejected">Rejected</option>
          <option value="all">All</option>
        </select>
        <select style={inp} value={empFilter} onChange={e => setEmpFilter(e.target.value)}>
          <option value="">All employees</option>
          {employees.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
        </select>
      </div>

      {err && <div style={{ color: '#dc2626', fontSize: 13, marginBottom: 12 }}>{err}</div>}

      <div style={card}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: 'var(--hairline)' }}>
              {['Employee', 'Type', 'From', 'To', 'Days', 'Reason', 'Status', ''].map(h => (
                <th key={h} style={{ padding: '9px 10px', textAlign: 'left', color: 'var(--text-2)', fontWeight: 600, borderBottom: '1px solid var(--glass-border)' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} style={{ borderBottom: '1px solid var(--hairline)' }}>
                <td style={{ padding: '9px 10px', fontWeight: 600 }}>{r.employee_name}<div style={{ fontSize: 11, color: 'var(--muted)', fontWeight: 400 }}>{r.department || ''}</div></td>
                <td style={{ padding: '9px 10px', textTransform: 'capitalize' }}>{r.type}</td>
                <td style={{ padding: '9px 10px' }}>{r.start_date}</td>
                <td style={{ padding: '9px 10px' }}>{r.end_date}</td>
                <td style={{ padding: '9px 10px' }}>{r.days || '—'}</td>
                <td style={{ padding: '9px 10px', color: 'var(--muted)' }}>{r.reason || '—'}</td>
                <td style={{ padding: '9px 10px' }}>
                  <span style={{ background: STATUS_COLORS[r.status] + '20', color: STATUS_COLORS[r.status], padding: '2px 9px', borderRadius: 12, fontWeight: 600, fontSize: 11, textTransform: 'capitalize' }}>{r.status}</span>
                </td>
                <td style={{ padding: '9px 10px', whiteSpace: 'nowrap' }}>
                  {r.status === 'pending' && (
                    <>
                      <button onClick={() => review(r.id, 'approved')} style={{ background: '#059669', color: '#fff', border: 'none', borderRadius: 6, padding: '5px 12px', fontSize: 12, cursor: 'pointer', marginRight: 6 }}>Approve</button>
                      <button onClick={() => review(r.id, 'rejected')} style={{ background: 'var(--glass)', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 6, padding: '5px 12px', fontSize: 12, cursor: 'pointer' }}>Reject</button>
                    </>
                  )}
                  {r.status !== 'pending' && r.reviewed_at && <span style={{ fontSize: 11, color: 'var(--muted)' }}>{new Date(r.reviewed_at).toLocaleDateString()}</span>}
                </td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={8} style={{ textAlign: 'center', color: 'var(--muted)', padding: 28 }}>No {statusFilter !== 'all' ? statusFilter : ''} requests.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
